import React from 'react';
import { blogPosts } from '../data/blogData';
import { FaWhatsapp } from 'react-icons/fa';

const Blog = () => {
  // Display only first 6 posts to keep page light
  const displayPosts = blogPosts.slice(0, 6);

  // Brand Logo Component to replace images
  const BrandLogo = ({ city }) => (
    <div className="w-full h-full bg-black flex flex-col items-center justify-center p-6 border-b-4 border-mx-green relative overflow-hidden group-hover:bg-zinc-900 transition-colors">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-20"></div>
      <div className="text-center relative z-10">
        <h3 className="text-3xl font-serif font-black text-white leading-none mb-1">
          EYELASHES<span className="text-mx-green">MEXICO</span>
        </h3>
        <p className="text-[10px] text-mx-gold tracking-[0.4em] uppercase mb-4">Made in Mexico</p>
        <div className="inline-block border border-white/20 bg-white/5 px-4 py-1 rounded-full backdrop-blur-sm">
          <span className="text-white font-bold text-xs uppercase tracking-wider">{city}</span>
        </div>
      </div>
      {/* Decorative Flag Line */}
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-mx-green via-white to-mx-red"></div>
    </div>
  );

  return (
    <section className="py-20 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-serif font-black text-black mb-4">LASH BLOG & NEWS</h2>
          <p className="text-xl text-gray-500 italic">Noticias y Consejos de Pestañas (500+ Cities)</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {displayPosts.map((post) => (
            <div key={post.id} className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all h-full flex flex-col border border-gray-100">
              <div className="h-48 bg-black relative overflow-hidden">
                <BrandLogo city={post.city} />
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <h3 className="text-xl font-bold mb-2 group-hover:text-mx-red transition-colors line-clamp-2">
                  {post.title}
                </h3>
                <p className="text-gray-500 text-sm italic mb-4 line-clamp-3 flex-1">
                  {post.excerpt}
                </p>
                <div className="mt-auto pt-4 border-t border-gray-100">
                  <a 
                    href={`https://wa.me/529841771113?text=I read about ${post.title} and want to book.`}
                    className="text-mx-gold font-bold text-sm uppercase tracking-wide flex items-center gap-2 hover:text-mx-green"
                  >
                    <FaWhatsapp /> Book in {post.city}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <p className="text-gray-400 text-sm italic">Showing 6 of 500+ location guides</p>
        </div>
      </div>
    </section>
  );
};

export default Blog;